import { getsessioninfojson } from "./getsessioninfojson";
import { ubtoa } from "./ubtoa";

export function SecureBufferE(org, user, theBuffer) {
  var jsonData = {};
  getsessioninfojson(jsonData);
  //  jsonData['sk'] =  gSessionKey;
  //  jsonData['zc'] =  gSessionCounter++;

  jsonData["org"] = ubtoa(org);
  jsonData["user"] = ubtoa(user);

  jsonData["data"] = ubtoa(theBuffer);

  var s = JSON.stringify(jsonData);
  return s;
}
